import React from "react";

const ErrorComponent404 = () => {
  return <h1>404 ERROR</h1>;
};

export default ErrorComponent404;
